import { IErrorResponse } from "@carm/_utils/models";

export interface IDeployment extends IErrorResponse {
  deploymentTime: number;
}

export const modalDeploymentConfig = {
  panelClass: 'sessionTimeoutDialog',
  backdropClass: 'carm-dialog-backdrop',
};
